#@import autosize
#@import Booking.Views.Base
#@import Booking.Presenters.Question
#@export Booking.Views.Question

class Booking.Views.Question extends Booking.Views.Base

  presenter: Booking.Presenters.Question

  templateName: 'question'

  events:
    'focus .focus-from-previous': 'focus'
    'focus .focus-from-field': 'focusPrevious'
    'click .label': 'focus'
    'blur textarea': 'willBlur'
    'change textarea': 'refreshStatus'
    'keyup textarea': 'refreshStatus'
    'keydown textarea': 'refreshStatus'
    'keypress textarea': 'newText'
    'paste textarea': 'truncatePaste'
    'click .clear': 'clear'

  constructor: ->
    Booking.Views.Base.apply this, arguments

    @listenTo @model, "questionsAnswer:preset", -> @render() if @canRender()

  canRender: ->
    @model.requireQuestion()

  render: ->
    Booking.Views.Base::render.apply this, arguments
    @$textarea = @$el.find('textarea')
    @textarea = @$textarea.get(0)
    @$textarea.autosize()
    @updateLabel(@$textarea.val())
    @refreshStatus()

  focus: ->
    clearTimeout(@willBlurTimer)
    @updateLabel()
    @$el.addClass('expanded')
    $(':focus').blur()
    @$textarea.focus()

  focusPrevious: ->
    @trigger 'focusPrevious'

  willBlur: ->
    @trimValue()
    @willBlurTimer = setTimeout(
      => @blur()
      10
    )

  blur: ->
    @$el.removeClass('expanded')
    @updateLabel(@$textarea.val())
    @triggerEvents()

  updateLabel: (value) ->
    value = @model.getQuestion() unless value
    @$el.find('.label').html(value)

  refreshStatus: ->
    @clearable()
    @triggerEvents()

  trimValue: ->
    @textarea.value = @textarea.value.trim()

  newText: ->
    @refreshStatus()
    unless 'maxLength' in @textarea
      maxLength = @textarea.attributes.maxLength.value
      if @textarea.value.length >= maxLength
        @textarea.value = @textarea.value.slice(0, maxLength)
        return false

  truncatePaste: (e) ->
    @clearable()
    unless 'maxLength' in @textarea
      maxLength = @textarea.attributes.maxLength.value
      paste = e.originalEvent.clipboardData.getData('Text')
      if @textarea.value.length + paste.length >= maxLength
        @textarea.value += paste.slice(0, maxLength - @textarea.value.length)
        return false

  clearable: ->
    method = if @textarea.value.length then 'addClass' else 'removeClass'
    @$el[method]('clearable')

  clear: ->
    clearTimeout(@willBlurTimer)
    @textarea.value = ''
    @triggerEvents()
    @clearable()
    @focus()


  triggerEvents: ->
    value = @textarea.value
    if value?.length
      event = 'complete'
      @hideInvalid()
      @model.setQuestionsAnswer value
    else
      event = 'incomplete'
      @model.setQuestionsAnswer undefined

    @trigger event, value

  shouldShowInvalid: ->
    @model.needQuestionsAnswers()

  showInvalid: ->
    @$('.wrapper').addClass('invalid')

  hideInvalid: ->
    @$('.wrapper').removeClass('invalid')
